import { UpcomingShowApi } from '../../generated/api';
import configuration from './configuration';

export const upcomingShowService = new UpcomingShowApi(configuration);
